import FEEDBACK_CONSTANTS from '@/constants/feedbackConstants';

export default {
  heading: 'Ne pare rău că articolul nu a fost de ajutor. Vreți să ne spuneți ce a fost greșit?',
  text: '',
  form: {
    fields: [
      {
        type: 'checkbox',
        name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME,
        items: [
          {
            label: 'Informațiile pe care le caut lipsesc',
            value: 'missing_information',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Există erori factuale',
            value: 'factual_errors',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          },
          {
            label: 'Unele aspecte sunt neclare',
            value: 'not_clear',
            name: FEEDBACK_CONSTANTS.FEEDBACK_CATEGORY_NAME
          }
        ]
      },
      {
        name: FEEDBACK_CONSTANTS.FEEDBACK_NAME,
        placeholder: 'Oferiți-ne informații generale și vom îmbunătăți acest articol.',
        type: 'textarea'
      }
    ],
    submit: {
      label: 'Trimiteți'
    }
  }
};
